var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('LoadIndicator',{model:{value:(_vm.isLoading),callback:function ($$v) {_vm.isLoading=$$v},expression:"isLoading"}}),_c('CRMSearchForm',{on:{"submit":_vm.doSearch}}),_c('CRMSearchResultsContainer',{attrs:{"results":_vm.searchResult,"has-loaded-once":_vm.hasLoadedOnce}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }